import HeaderSection from '../../../../../components/Header/HeaderSection';
import CardTransparent from '../../../../../components/CockpitCards/CardTransparent';


export default function PharmaDrugsText() {

    
    return (

    <CardTransparent content = {
        <HeaderSection

            headline_p1 = "Your" 
            headline_grey = "Full Report "
            headline_p2 = "for Pharmacogenetic Recommendations"

            text1 = "This section presents all available drug recommendations based on clinical guidelines and your individual pharmacogenetic profile. The insights provided here are intended to support more personalized and effective treatment decisions."
            text2 = "Always consult with your doctor or pharmacist before making any changes to your medication plan and consider sharing this information with them as part of your ongoing care."
            text3 = ""

            />
    }/>
            
  )
}